import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/tokens.css'
import './styles/mobile.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { resolveApiBaseURL } from './utils/appBase'
import { bindPageContextRouter } from './stores/pageContext'

// 生产环境根路径部署时，裸 axios 请求走同源 baseURL
axios.defaults.baseURL = resolveApiBaseURL()

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
bindPageContextRouter(router)
app.use(ElementPlus)
app.mount('#app')
